import React from 'react';

import {Modal, message} from 'antd';

import fetch from './fetch';
import utils from './../utils';
import user from './user';

//50002
const transform = (response) => {
    const data = response.payload.data;
    let userId;
    if (data.userType === 1) {
        userId = data.studentId
    } else if (data.userType === 2) {
        userId = data.employeeId
    } else if (data.userType === 3) {
        userId = data.masterId
    }
    return {
        success: true,
        code: response.code,
        message: response.message,
        payload: {
        account: {
            id: userId,
            loginName: data.loginName,
            realName: data.realName,
            orgName : data.orgXzName,
            orgId : data.orgXzId,
            schoolName: data.schoolName,
            termName: data.termName,
            yearName: data.yearName,
            termId: data.termId,
            yearId: data.yearId,
            dudao: data.dudao,
            systemName: data.systemName,
            userType: data.userType,
            orgId : (data.org || {}).orgId ,
            orgName : (data.org || {}).orgName ,
        },
        rules: data.roleModuleList.map((rule) => {
            if((rule.url || "").indexOf('/datav/index/') !== -1) {
                var link = rule.url.split('/datav/index/')[1];
                if(link) {
                    rule.url = "/datav/index/"+escape(link);
                }
            }
            return {
                id: rule.id,
                name: rule.name,
                pid: rule.pid,
                url: rule.url,
                depth: rule.level,
                icon: rule.icon,
                label: rule.label,
                orderNum: rule.orderNum
            }
        }),
        roleIds: data.roleIds,
        operationList: data.operationList,
        show: data.display
        }
    };
}

const saveSession = (data) => {
    var result = utils.tree(data.payload.rules);
    const operation = {};

    data.payload.operationList.forEach(item => {
        operation[item.operationUrl] = {
            name: item.operationName,
            enabled: item.enabled,
            show: data.payload.show
        }
    });

    window.sessionStorage.setItem('session', JSON.stringify({
        account: data.payload.account,
        rules: (result && result.length > 0) ? result[0].children : [],
        roleIds: data.payload.roleIds,
        operation: operation
    }));
    
    return data.payload;
}

const login = (options) => {
    const params = {
        userName: options.username,
        pwd: md5(options.password),
        // oldPwd: options.password,
        kaptcha: options.kaptcha,
        relogin:options.relogin
    };
    let url = 'employee/login'
    if (options.roleId === 1) {
        url = 'student/login'
    }else if(options.roleId === 3){
        url = 'graduation/login'
    }
    return fetch.post(url, params)
    .then(response => {
        if(response.code === 200) {
            return transform(response);
        }else if(response.code === 412){
            return {
                success: false,
                code : 412,
                message: '您的密码为初始化密码，请您修改密码后再进行登录'
            }
        }else if(response.code === 60003){
            return {
                success: false,
                code : 60003,
                message: '您的账号已经登录，请问是否继续登录？'
            }
        } else {
            return {
                success: false,
                message: response.message
            };
        }
    })
    .then(data => {
        if(data.success) {
            return saveSession(data);
        }
        
        // if(data.code != undefined && data.code === 412){
        //     return {
        //         code : 412
        //     }
        // }
        return data
    });
}

const logout = (options) => {
    return fetch.post('employee/logout', {});
}

const website = () => {
    return fetch.get('index', {})
    .then(response => {
        return response.payload.data;
    });
}

const getKaphcha = () => {
    return fetch.base + 'kaptcha?v=' + Math.random()
}

export default {
    login,
    getKaphcha,
    website,
    logout
}